import { onAuthStateChanged, signInWithEmailAndPassword, signOut, User } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/firebase';
import { ERPUser } from './types';
export function login(email:string,password:string){return signInWithEmailAndPassword(auth,email,password)}
export function logout(){return signOut(auth)}
export function listenAuth(callback:(firebaseUser:User|null,erpUser:ERPUser|null,error?:string)=>void){
 return onAuthStateChanged(auth,async(user)=>{
  if(!user){callback(null,null);return}
  try{
   const snap=await getDoc(doc(db,'users',user.uid));
   if(!snap.exists()){callback(user,null,'ERP user document missing.');return}
   const data=snap.data() as any;
   const normalized:ERPUser={uid:String(data.uid||user.uid),name:String(data.name||data.fullName||user.email||'User'),email:String(data.email||user.email||''),role:data.role||'staff',department:data.department||data.primaryDepartment||'general',status:data.status||((data.isActive===true)?'active':'inactive')};
   if(normalized.status!=='active'){callback(user,null,'Your ERP user account is not active.');return}
   callback(user,normalized);
  }catch(err){callback(user,null,err instanceof Error?err.message:'Unable to load ERP user profile.')}
 })
}
